// extracted by mini-css-extract-plugin
module.exports = {"form":"components_form__2z3su","row":"components_row__1hDFd","actions":"components_actions__Su1PM"};